/**
 * 消耗任务数据工具 - 档位表由服务器接口下发（/v1/config/consumptionActivity 的 missions 字段），
 * 与本组件配套的 ConsumptionActivityResolver.resolve().missions 同源，免每期手工维护硬编码数据。
 */

// 消耗任务ID枚举 - 严格与后端保持一致（5种悬赏任务类型跨期稳定）
export const ConsumptionTaskID = {
  招募: 1,
  宝箱: 2,
  捕获: 3,
  盐罐: 4,
  金砖: 5
};

/**
 * 把接口下发的扁平档位数组按悬赏类型分组。
 * @param missions [{id,type,num,rewardLv1,rewardRank}]
 * @returns { [type]: missions[] }，各类型内按id升序
 */
export const groupMissionsByType = (missions = []) => {
  const byType = {};
  for (const m of missions ?? []) {
    (byType[m.type] = byType[m.type] || []).push(m);
  }
  Object.values(byType).forEach(arr => arr.sort((a, b) => a.id - b.id));
  return byType;
};

/**
 * 工具函数：获取某悬赏类型的任务档位配置。
 * @param grouped groupMissionsByType 的分组结果
 * @param taskId 悬赏类型ID（ConsumptionTaskID）
 */
export const getTaskConfigs = (grouped, taskId) => {
  return grouped?.[taskId] || [];
};

/**
 * 工具函数：获取所有任务类型（可选按当期有档位数据的类型过滤）。
 * @param grouped 可选，传入时只返回有档位数据的任务类型
 */
export const getAllTaskTypes = (grouped = null) => {
  return Object.keys(ConsumptionTaskID)
    .map(key => ({
      id: ConsumptionTaskID[key],
      name: key
    }))
    .filter(t => !grouped || (grouped[t.id] ?? []).length > 0);
};
